import { DocsCsvUploadWizard } from "./docs-csv-upload-wizard"

export function DocsCsvUploadField() {
	return (
		<>
			<div>
				<header className="space-y-1 text-sm">
					<div className="text-base font-medium">File upload</div>
					<div className="mb-6 text-secondary">Import Docs from a CSV file</div>
				</header>
				<div className="mt-4 overflow-hidden">
					<DocsCsvUploadWizard />
				</div>
			</div>
		</>
	)
}
